"use strict";
/**
 * im 事件
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IMEvent = void 0;
var tiptoast_1 = __importDefault(require("../../../../modules/modal/tiptoast"));
var em_im_1 = __importDefault(require("../../../../modules/em_im"));
/**
 * 直播im事件
 */
exports.IMEvent = {
    /**
     * 踢出直播间
     */
    onKickOut: function () {
        em_im_1.default.onKickOut(function () {
            tiptoast_1.default.show({
                content: "您已被踢出直播间",
                callback: function () {
                    window.location.href = "http://roadshow.eastmoney.com/";
                }
            });
        });
    },
    /**
     * 直播开始
     */
    onShowStart: function () {
        em_im_1.default.onShowStart(function () {
            setTimeout(function () {
                self.location.reload();
            }, 10 * 1000);
        });
    },
    /**
     * 主播离开
     */
    onPresentersLeft: function (callback) {
        em_im_1.default.onPresentersLeft(function () {
            setTimeout(function () {
                callback && callback();
            }, 10 * 1000);
        });
    },
    /**
     * 直播继续
     */
    onPresentersContinue: function (callback) {
        em_im_1.default.onPresentersContinue(function (res) {
            var _a, _b;
            var avsrc = "";
            if (typeof (res === null || res === void 0 ? void 0 : res.Content) == "string") {
                avsrc = ((_b = (_a = JSON.parse(res === null || res === void 0 ? void 0 : res.Content)) === null || _a === void 0 ? void 0 : _a.message) === null || _b === void 0 ? void 0 : _b.live_hls_addr) || "";
            }
            setTimeout(function () {
                $("#ly-err-label").remove();
                // $('#ly_vedio_media').empty();
                // that.reloadVideo();
                callback && callback(avsrc);
            }, 15 * 1000);
        });
    },
    /**
     * 直播结束
     */
    onShowEnd: function () {
        em_im_1.default.onShowEnd(function () {
            setTimeout(function () {
                self.location.reload();
            }, 10 * 1000);
        });
    },
    /**
     * 测试结束
     */
    onShowTestEnd: function () {
        em_im_1.default.onShowTestEnd(function () {
            console.log("finish test");
            setTimeout(function () {
                // alert("finish")
                self.location.reload();
            }, 10 * 1000);
        });
    },
    /**
     * 直播测试地址变更
     */
    onChangeLiveTestshow: function () {
        console.log("change test");
        em_im_1.default.onChangeLiveTestshow(function () {
            console.log("change test");
            setTimeout(function () {
                self.location.reload();
            }, 15 * 1000);
        });
    }
};
//# sourceMappingURL=data:application/json;base64,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